import {
  Chip,
  HStack,
  Pressable,
  Text,
} from '@ayble-health/dashboard-components';
import React from 'react';
import { Box, useToken } from '@chakra-ui/react';
import { ChevronRight, Clock } from 'lucide-react';
import CalendarSVG from '../../CustomSVGs/CalendarSVG';

type Props = {
  date: string;
  onPress: () => void;
  providerLabel: string;
  requestedTimeframe?: string | null;
};

export const VisitBlockCard = ({
  date,
  onPress,
  providerLabel,
  requestedTimeframe,
}: Props) => {
  const [seafoam] = useToken('colors', ['seafoam']);

  return (
    <Pressable onClick={onPress} w={'100%'}>
      <Box w={'100%'}>
        <HStack justifyContent={'space-between'} w={'100%'}>
          <Text
            color={'secondary.500'}
            fontSize={'16px'}
            fontWeight={'normal'}
            textAlign={'left'}
          >
            {providerLabel}
          </Text>

          <Chip variant={'canvas'} fontSize={'xs'} fontWeight={'semibold'}>
            Unscheduled
          </Chip>
        </HStack>

        <HStack alignItems={'center'} justifyContent={'space-between'} mt={2}>
          <HStack alignItems={'center'} gap={1}>
            <CalendarSVG height={12} width={12} />
            <Text color={'blueGray.600'} fontSize={'12px'}>
              Requested on: {date}
            </Text>
          </HStack>

          <ChevronRight color={seafoam} size={16} />
        </HStack>

        <HStack alignItems={'center'} gap={1} mt={1}>
          <Clock color={seafoam} size={12} />
          <Text color={'blueGray.600'} fontSize={'12px'}>
            {requestedTimeframe || 'Timeframe: --'}
          </Text>
        </HStack>
      </Box>
    </Pressable>
  );
};
